export default "__VITE_ASSET__693b9b21__"